import {
  createSignal,
  createEffect,
  createResource,
  observable,
  on,
} from "https://cdn.jsdelivr.net/npm/solid-js@1.9.5/+esm";

import StorefrontCart from "https://cdn.jsdelivr.net/npm/@bryt-designs/storefront-cart@2.2.41";

window.DiscountApp = (function () {
  const [discountCode, setDiscountCode] = createSignal("");

  const [discountInfo, _] = createResource(
    discountCode,
    async (discountCode) => {
      if (!discountCode) return;

      const url = `/apps/gem-bryt/discounts/${discountCode}`;

      const res = await fetch(url, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!res.ok) throw new Error(`${res.status}`);

      const data = await res.json();

      let formattedValue = "";

      if (data?.code?.amount?.type === "PERCENTAGE") {
        formattedValue = `${Math.round(data.code.amount.value * 100)}%`;
      }

      if (data?.code?.amount?.type === "FLAT") {
        formattedValue = Shopify.formatMoney(
          parseFloat(data.code.amount.value) * 100,
        );
      }

      if (!data?.customMessage || !data?.code)
        return {
          ...data,
          formattedAmount: {
            type: data?.code?.amount?.type,
            value: formattedValue,
          },
        };

      let customMessage = data.customMessage;

      customMessage = customMessage.replace(
        /(\{\{\s*code.title\s*\}\})/g,
        data.code.title,
      );

      if (data?.code?.amount?.type === "PERCENTAGE") {
        customMessage = customMessage.replace(
          /(\{\{\s*code.amount\s*\}\})/g,
          formattedValue,
        );
      }

      if (data?.code?.amount?.type === "FLAT") {
        customMessage = customMessage.replace(
          /(\{\{\s*code.amount\s*\}\})/g,
          formattedValue,
        );
      }

      if (data?.code?.amount?.type === "FREE-SHIPPING") {
        customMessage = customMessage.replace(
          /(\{\{\s*code.amount\s*\}\})/g,
          "",
        );
      }

      return {
        ...data,
        customMessage,
        formattedAmount: {
          type: data?.code?.amount?.type,
          value: formattedValue,
        },
      };
    },
  );

  createEffect(
    on(
      () => StorefrontCart.isInitialLoading,
      async (isLoading) => {
        if (isLoading) return;
        if (!StorefrontCart.cart()) return;
        const appliedDiscounts = StorefrontCart.cart().discountCodes;

        const discountsMatch = appliedDiscounts.some(
          (discount) => discount.code === discountCode(),
        );

        if (discountsMatch) return;

        appliedDiscounts.forEach(async (discount) => {
          await StorefrontCart.removeDiscountCode(discount.code);
        });

        if (!discountCode()) {
          // Ragnar wanted to apply 20% discount if no discount is currently applied
          // const url = new URL(window.location.href);
          // url.searchParams.append("discount", "WELCOME20");
          // window.location.search = url.searchParams;
          // await StorefrontCart.addDiscountCode("WELCOME20");
          return;
        }

        await StorefrontCart.addDiscountCode(discountCode());
      },
    ),
    { defer: true },
  );

  createEffect(() => {
    let discountCode = getDiscountCodeFromURL() || getDiscountCodeFromSession();

    if (!discountCode)
      return console.warn("No discount code found in URL or session storage");

    setDiscountCode(discountCode);
  });

  createEffect(() => {
    if (!discountCode()) return;
    const anchors = document.querySelectorAll('a[href*="/"]');
    anchors.forEach((anchor) => {
      const href = anchor.href;

      if (href.startsWith("https://")) {
        const url = new URL(href);
        url.searchParams.set("discount", discountCode());
        anchor.setAttribute("href", url.href);
      } else {
        const url = new URL(window.location.origin + href);
        url.searchParams.set("discount", discountCode());
        anchor.setAttribute("href", url.href);
      }
    });
    applyDiscountCode(discountCode());
  });

  function getDiscountCodeFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("discount");
  }

  function getDiscountCodeFromSession() {
    return sessionStorage.getItem("discount");
  }

  async function applyDiscountCode(code) {
    try {
      await StorefrontCart.addDiscountCode(code);

      if (getDiscountCodeFromURL()) {
        sessionStorage.setItem("discount", code);
      }
    } catch (error) {
      console.warn("Failed to apply discount code:", error);
    }
  }

  const subscribe = (cb) => {
    const observer = observable(discountInfo);
    return observer.subscribe(cb).unsubscribe;
  };

  return {
    discount: discountInfo,
    subscribe,
    update: (code) => setDiscountCode(code),
  };
})();
